// p/file/download/{fileName} => p/file/thumbnail/{fileName}/thumb.png
// /p/file/download2/{fileId}/{fileName} => /p/file/thumbnail2/{fileId}/{fileName}/thumb.png
export function toThumbnailUrl(url: string): string | undefined {
  if (url.includes('/file/download/')) {
    return url.replace('/file/download/', '/file/thumbnail1/') + '/thumb.png';
  }

  if (url.includes('/file/download2/')) {
    return url.replace('/file/download2/', '/file/thumbnail2/') + '/thumb.png';
  }

  return undefined;
}
